import { onlineBookingBackThunk } from 'actions/onlineBooking/OnlineBookingActions';
import { Header } from 'components/Layout/Header/Header';
import { TwoColumnsLayout } from 'components/Layout/TwoColumns/TwoColumnsLayout';
import { OnlineBookingAddPetStep } from 'components/OnlineBooking/Steps/AddPet/OnlineBookingAddPetStep';
import { OnlineBookingHomeStep } from 'components/OnlineBooking/Steps/Home/OnlineBookingHomeStep';
import { OnlineBookingNewClientStep } from 'components/OnlineBooking/Steps/NewClient/OnlineBookingNewClientStep';
import { OnlineBookingNotesAndAgreementsStep } from 'components/OnlineBooking/Steps/NotesAndAgreements/OnlineBookingNotesAndAgreementsStep';
import { OnlineBookingPaymentStep } from 'components/OnlineBooking/Steps/Payment/OnlineBookingPaymentStep';
import { OnlineBookingSelectDateTimeStep } from 'components/OnlineBooking/Steps/SelectDatetime/OnlineBookingSelectDateTimeStep';
import { OnlineBookingSelectPetsStep } from 'components/OnlineBooking/Steps/SelectPets/OnlineBookingSelectPetsStep';
import { OnlineBookingSelectServicesStep } from 'components/OnlineBooking/Steps/SelectServices/OnlineBookingSelectServicesStep';
import { OnlineBookingSelectStaffStep } from 'components/OnlineBooking/Steps/SelectStaff/OnlineBookingSelectStaffStep';
import { OnlineBookingSigninStep } from 'components/OnlineBooking/Steps/Signin/OnlineBookingSigninStep';
import { OnlineBookingSuccessStep } from 'components/OnlineBooking/Steps/Success/OnlineBookingSuccessStep';
import { useMarketplace } from 'hooks/useMarketplace';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getOnlineBookingBackEnabled,
    getOnlineBookingStep
} from 'reducers/onlineBooking/OnlineBookingSelectors';
import { OnlineBookingStep } from 'types/OnlineBooking';

export const OnlineBookingForm: React.FC = () => {
    const dispatch = useDispatch();
    const marketplace = useMarketplace();

    const step = useSelector(getOnlineBookingStep);
    const isBackEnabled = useSelector(getOnlineBookingBackEnabled);

    const progress = React.useMemo(() => {
        switch (step) {
            case OnlineBookingStep.NewClientForm:
                return 18;
            case OnlineBookingStep.Signin:
                return 27;
            case OnlineBookingStep.AddPet:
                return 36;
            case OnlineBookingStep.SelectPets:
                return 45;
            case OnlineBookingStep.SelectServices:
                return 54;
            case OnlineBookingStep.SelectStaff:
                return 63;
            case OnlineBookingStep.SelectDateTime:
                return 72;
            case OnlineBookingStep.NotesAndAgreements:
                return 81;
            case OnlineBookingStep.Payment:
                return 90;
            case OnlineBookingStep.Success:
                return 100;
            default:
                return 10;
        }
    }, [step]);

    const renderedStep = React.useMemo(() => {
        const stepComponents = {
            [OnlineBookingStep.Home]: OnlineBookingHomeStep,
            [OnlineBookingStep.NewClientForm]: OnlineBookingNewClientStep,
            [OnlineBookingStep.Signin]: OnlineBookingSigninStep,
            [OnlineBookingStep.AddPet]: OnlineBookingAddPetStep,
            [OnlineBookingStep.SelectPets]: OnlineBookingSelectPetsStep,
            [OnlineBookingStep.SelectServices]: OnlineBookingSelectServicesStep,
            [OnlineBookingStep.SelectStaff]: OnlineBookingSelectStaffStep,
            [OnlineBookingStep.SelectDateTime]: OnlineBookingSelectDateTimeStep,
            [OnlineBookingStep.NotesAndAgreements]: OnlineBookingNotesAndAgreementsStep,
            [OnlineBookingStep.Payment]: OnlineBookingPaymentStep,
            [OnlineBookingStep.Success]: OnlineBookingSuccessStep
        };

        const StepComponent = stepComponents[step];
        return StepComponent ? <StepComponent /> : null;
    }, [step]);

    const backHandler = () => dispatch(onlineBookingBackThunk());

    return (
        <TwoColumnsLayout
            header={
                <Header
                    progress={progress}
                    logo={marketplace.logo}
                    onBack={isBackEnabled ? backHandler : undefined}
                />
            }
        >
            {renderedStep}
        </TwoColumnsLayout>
    );
};
